import { createContext } from 'react';

import { QRUserRole } from '@totem/components/services/remoteAccess/v2/users/types';

interface Context {
  loading: boolean;
  rows: QRUserRole[];
  emailSearch: string;
  setEmailSearch: (value: string) => void;
  nameSearch: string;
  setNameSearch: (value: string) => void;
  selectedUserIds: string[];
  setSelectedUserIds: (value: string[]) => void;
  onRefresh: () => void;
}

export default createContext<Context>({
  loading: false,
  rows: [],
  emailSearch: '',
  setEmailSearch: () => {},
  nameSearch: '',
  setNameSearch: () => {},
  selectedUserIds: [],
  setSelectedUserIds: () => {},
  onRefresh: () => {},
});
